import { useBehaviorSubject } from '@euler/utils/hooks';
import { useChatSession } from '../context';

export const useChatUnreadCount = (): number => {
  const { chatUnreadCount$ } = useChatSession();
  const [count] = useBehaviorSubject(chatUnreadCount$);
  return count;
};
